import React from "react";
import "./App.scss";
import AppRouter from "./routes";
import { connect } from "react-redux";
import { history } from "./utils/history";
import { ToastContainer, toast } from 'react-toastify';
class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  renderLoader() {
    return <></>;
  }
  componentDidMount(){
    document.addEventListener("deviceready", this.onDeviceReady(), false);
  }

  onDeviceReady() {
    // Your web app's Firebase configuration
    var firebaseConfig = {
      apiKey: "AIzaSyAo06gJY_liK-za5GO4TfHj3gAAY0oTpjA",
      authDomain: "neighborgood-95f9b.firebaseapp.com",
      databaseURL: "https://neighborgood-95f9b.firebaseio.com",
      projectId: "neighborgood-95f9b",
      storageBucket: "neighborgood-95f9b.appspot.com",
      messagingSenderId: "549929466205",
      appId: "1:549929466205:web:57d918c153c3e3367190b4",
      measurementId: "G-X6QVND10TX"
    };
    // Initialize Firebase
    window.firebase.initializeApp(firebaseConfig);
    localStorage.getItem('access_token') ? 
    history.push('/home') :
    history.push('/login')
  }
  render() {
    const { state, props } = this;
    return (
      <>
        <AppRouter />
        <ToastContainer />
        {props.loader.isLoading && this.renderLoader(props.loader.page)}
      </>
    );
  }
}
const mapStateToProps = ({ loader }) => ({
  loader
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(App);
